import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Stack,
  Box,
  Chip,
  Button,
  Divider,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const boolChip = (value) => {
  if (value === true) return { label: 'Sim', color: 'success' };
  if (value === false) return { label: 'Não', color: 'error' };
  return { label: 'Indisponível', color: 'default' };
};

function LinhaDiagnostico({ label, value, isBool = false }) {
  const chip = isBool ? boolChip(value) : null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
      }}
    >
      <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.78)' }}>
        {label}
      </Typography>
      {isBool ? (
        <Chip size="small" label={chip.label} color={chip.color} />
      ) : (
        <Typography variant="body2" sx={{ fontWeight: 600, color: '#fff' }}>
          {value || 'N/A'}
        </Typography>
      )}
    </Box>
  );
}

export default function NaoAtendidoDiagnosticoDialog({ open, onClose, item }) {
  const qtdOnline =
    item?.diagnostico?.atendentesOnlineNoMomento ??
    item?.contextoLogin?.atendentesOnlineNoMomento ??
    0;

  const diagnostico = {
    servidorOnlineNoMomento: item?.diagnostico?.servidorOnlineNoMomento ?? true,
    haviaAtendentesOnline:
      item?.diagnostico?.haviaAtendentesOnline ?? (qtdOnline > 0),
    atendenteFoiNotificadoDaFila:
      item?.diagnostico?.atendenteFoiNotificadoDaFila ?? (qtdOnline > 0),
    atendentesOnlineNoMomento: qtdOnline,
    proximoLogin:
      item?.diagnostico?.proximoLogin || item?.contextoLogin?.proximoLogin || 'N/A',
    criterioNotificacaoFila:
      item?.diagnostico?.criterioNotificacaoFila ||
      'Diagnóstico inferido pelo histórico de login/logout no momento da saída da fila.',
    atendentesOnlineNomes:
      item?.diagnostico?.atendentesOnlineNomes ||
      item?.contextoLogin?.atendentesOnlineNomes ||
      [],
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          bgcolor: '#111827',
          color: '#fff',
          border: '1px solid rgba(255,255,255,0.12)',
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <InfoOutlinedIcon fontSize="small" />
        Diagnóstico de Não Atendimento
      </DialogTitle>

      <DialogContent>
        <Stack spacing={1.3}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
            {item?.clienteNome || item?.title || 'Cliente desconhecido'}
          </Typography>
          <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.75)' }}>
            {item?.motivo || 'Motivo não informado'}
          </Typography>

          <Divider sx={{ borderColor: 'rgba(255,255,255,0.12)', my: 1 }} />

          <LinhaDiagnostico
            label="Servidor estava online no momento?"
            value={diagnostico?.servidorOnlineNoMomento}
            isBool
          />
          <LinhaDiagnostico
            label="Havia atendentes online?"
            value={diagnostico?.haviaAtendentesOnline}
            isBool
          />
          <LinhaDiagnostico
            label="Atendente foi notificado da fila?"
            value={diagnostico?.atendenteFoiNotificadoDaFila}
            isBool
          />
          <LinhaDiagnostico
            label="Quantidade de atendentes online"
            value={diagnostico?.atendentesOnlineNoMomento ?? '0'}
          />
          <LinhaDiagnostico
            label="Atendentes online no momento"
            value={
              Array.isArray(diagnostico?.atendentesOnlineNomes) &&
              diagnostico.atendentesOnlineNomes.length > 0
                ? diagnostico.atendentesOnlineNomes.join(', ')
                : 'N/A'
            }
          />
          <LinhaDiagnostico
            label="Próximo login após a saída"
            value={diagnostico?.proximoLogin || 'N/A'}
          />

          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.56)', mt: 1 }}>
            {diagnostico?.criterioNotificacaoFila || ''}
          </Typography>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained" sx={{ textTransform: 'none' }}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
